import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { SynergoRequisitionService } from '../../../service/synergo-requisition/synergo-requisition.service';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem, DataTable } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { CustomerGuide } from '../../../class/customer-guide';
import { CompanyService } from '../../../service/company/company.service';
import { config } from '../../../../../../environments/config';
import { Requisition } from '../../../class/requisition';
import { RequisitionJustificationService } from '../../../service/requisition-justification/requisition-justification.service';
import { RequisitionJustification } from '../../../class/requisition-justification';
import { RequisitionTaskService } from '../../../service/requisition-task/requisition-task.service';
import { RequisitionTask } from '../../../class/requisition-task';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';



@Component({
  selector: 'app-synergo-requisitions',
  templateUrl: './synergo-requisitions.component.html',
  styleUrls: ['./synergo-requisitions.component.scss']
})
export class SynergoRequisitionsComponent implements OnInit, OnDestroy {

    @Input() customerGuide: CustomerGuide;

    public promiseForm: Promise<any>;

    edit1: Requisition;
    public form: FormGroup;
    public form2: FormGroup;

    public msgs: Message[] = [];
    public requisitions: Requisition[];
    public selectRequisition: Requisition;
    public RequisitionID: Number = 0;
    public modNew = false;
    public modView = false;
    public openRequisition = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public filtersKanban: {key: string, value: string}[];
    public sort: string;
    public query: string;

    public form3: FormGroup;
    public company_id_filter: AbstractControl;
    public employee_id_filter: AbstractControl;
    public venue_id_filter: AbstractControl;
    public status_filter: AbstractControl;
    public type_filter: AbstractControl;

    public recruited_by_id_filter: AbstractControl;
    public requisition_recruitment_filter: AbstractControl;
    public requisitionRecruitments: SelectItem[];

    public statusOptions: SelectItem[];
    public typeOptions: SelectItem[];
    public exportOptions: SelectItem[];
    public ReportTypeExportOptions: SelectItem[];

    public selectedReportTypeExportOptions: {label: string, value: string};

    public params_id_customer_guide: number = 0;
    public params_id_company: number;
    public params_id_requisition: number;

    public employeePositionToLoadSelection: string;

    public filters: any[];

    public first = 0;

    public modExportDialog: boolean;

    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    public f4_venue_id: AbstractControl;
    public f4_employee_id: AbstractControl;
    public f4_company_id: AbstractControl;
    public f4_status_filter: AbstractControl;
    public f4_type_filter: AbstractControl;
    public f4_export_filter: AbstractControl;
    public f4_export_type_filter: AbstractControl;

    public justification: AbstractControl;
    public listRequisitionJustification: any[];
    public totalRecordsRequisitionJustification: number;
    public totalRecordsRequisitionTask: number;

    public displaySidebarJustification: boolean;
    public displaySidebarTask: boolean;

    public listAbierta: any;
    public listCerrada: any;

    public apiUrl = config.API_ROOT;

    public reloadInterval: any;
    public loading: boolean;

    public showCreateTask: boolean;

    public es: any;

    @ViewChild('dt') dataTable: DataTable;

    constructor(
        public synergoRequisitionService: SynergoRequisitionService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        public activatedRoute: ActivatedRoute,
        public hasPermissionService: HasPermissionService,
        public router: Router,
        public companyService: CompanyService,
        public requisitionJustificationService: RequisitionJustificationService,
        public requisitionTaskService: RequisitionTaskService,
        public fb: FormBuilder) {
            this.es = calendarES();

            this.showCreateTask = false;

                this.statusOptions = [
                    {label: 'Todas', value: 'all'},
                    {label: 'Abierta', value: 'Abierto'},
                    //{label: 'En Proceso', value: 'En Proceso'},
                    {label: 'Congelado', value: 'Congelado'},
                    {label: 'Cerrada', value: 'Cerrado'},
                    //{label: 'Retirada', value: 'Retiro'},
                    //{label: 'Backup', value: 'Backup'},
                ];

                this.typeOptions = [
                    {label: 'Todas', value: 'all'},
                    {label: 'Proceso de Selección', value: 'Proceso de Selección'},
                    {label: 'Enviado por el cliente', value: 'Enviado por el cliente'},
                    {label: 'Reingreso', value: 'Reingreso'},
                ];

                this.exportOptions = [
                    {label: 'Excel', value: 'excel'},
                    {label: 'Pdf', value: 'pdf'},
                    // {label: 'Email', value: 'email'},
                ];

                this.ReportTypeExportOptions = [
                    {label: 'Reporte Requisición - General', value: 'Reporte Requisición - General'},
                    {label: 'Reporte Requisición - Gerencia', value: 'Reporte Requisición - Gerencia'},
                    {label: 'Reporte Requisición - Solicitados vs Enviados', value: 'Reporte Requisición - Solicitados vs Enviados'},
                    {label: 'Reporte Requisición - Enviados vs Contratados', value: 'Reporte Requisición - Enviados vs Contratados'},
                    {label: 'Reporte Requisición - Resumen Gestión', value: 'Reporte Requisición - Resumen Gestión'},
                    {label: 'Reporte Requisición - Resumen Alentti', value: 'Reporte Requisición - Alentti'},
                    {label: 'Reporte Requisición - Informe Contratación', value: 'Reporte Requisición - Informe Contratación'},
                ];
                this.requisitionRecruitments=[
                    {label: 'Cualquiera', value: ''},
                    {label: 'Reclutamiento solicitado', value: 'Reclutamiento solicitado'},
                    {label: 'Reclutamiento solicitado no asignado', value: 'Reclutamiento solicitado no asignado'},
                ]

                this.displaySidebarJustification = false;
                this.displaySidebarTask = false;


                this.form = fb.group({
                    'justification': [''],
                });

                this.form2 = fb.group({
                    'justification': ['', Validators.compose([Validators.required, Validators.minLength(2)])]
                });
                this.justification = this.form2.controls['justification'];

                this.form3 = fb.group({
                    'company_id_filter': [''],
                    'employee_id_filter': [''],
                    'venue_id_filter': [''],
                    'status_filter': [''],
                    'type_filter': [''],
                    'recruited_by_id_filter':[''],
                    'requisition_recruitment_filter':[''],
                });
                this.company_id_filter = this.form3.controls['company_id_filter'];
                this.employee_id_filter = this.form3.controls['employee_id_filter'];
                this.venue_id_filter = this.form3.controls['venue_id_filter'];
                this.status_filter = this.form3.controls['status_filter'];
                this.type_filter = this.form3.controls['type_filter'];
                this.recruited_by_id_filter = this.form3.controls['recruited_by_id_filter'];
                this.requisition_recruitment_filter = this.form3.controls['requisition_recruitment_filter'];
                // this.status_filter.setValue('all');
                // this.type_filter.setValue('all');

                this.employeePositionToLoadSelection = '4,5,38';

                this.activatedRoute.queryParams.subscribe(params => {
                    if (params['id_requisition']) {
                        this.params_id_requisition = Number(params['id_requisition']);
                        //this.filter();
                    }
                    if (params['id_customer_guide']) {
                        this.params_id_customer_guide = Number(params['id_customer_guide']);
                        if((this.params_id_customer_guide ==5 || this.params_id_customer_guide ==345) 
                            && !this.hasPermission("get company redes")){
                                this.params_id_customer_guide = undefined;
                        }
                    }
                    if (params['id_company']) {
                        this.params_id_company = Number(params['id_company']);
                        const filters = [];
                        if (this.params_id_company) {
                            if((this.params_id_company !=5 && this.params_id_company !=323) 
                                || this.hasPermission("get company redes")){
                                filters.push({key: 'id-lk', value: String(this.params_id_company)});
                            
                        }
                        }
                        this.getCompanies(undefined, filters);
                    }
                });

                this.form4 = fb.group({
                    'f4_date_start': ['', [Validators.required]],
                    'f4_date_end': ['', [Validators.required]],
                    'f4_venue_id': [''],
                    'f4_employee_id': [''],
                    'f4_company_id': [''],
                    'f4_status_filter': ['', Validators.required],
                    'f4_type_filter': ['', Validators.required],
                    'f4_export_filter': [''],
                    'f4_export_type_filter': [''],
                });
                this.f4_date_start = this.form4.controls['f4_date_start'];
                this.f4_date_end = this.form4.controls['f4_date_end'];
                this.f4_venue_id = this.form4.controls['f4_venue_id'];
                this.f4_employee_id = this.form4.controls['f4_employee_id'];
                this.f4_company_id = this.form4.controls['f4_company_id'];
                this.f4_status_filter = this.form4.controls['f4_status_filter'];
                this.f4_type_filter = this.form4.controls['f4_type_filter'];
                this.f4_export_filter = this.form4.controls['f4_export_filter'];
                this.f4_export_type_filter = this.form4.controls['f4_export_type_filter'];
                // this.f4_status_filter.setValue('all');
                // this.f4_type_filter.setValue('all');
                this.f4_export_filter.setValue('excel');

                this.loading = true;
                this.modExportDialog = false;

                this.listRequisitionJustification = [];
                this.listAbierta = [];
                this.listCerrada = [];
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_requisition']) {
                this.params_id_requisition = Number(params['id_requisition']);
                const filters = [];
                filters.push({key: 'id-in', value: String(this.params_id_requisition)});
                this.getRequisitionsById(this.query, filters);
            } else {
                //this.getRequisitions();
            }
        });

        this.reloadInterval = setInterval(() => {
            this.filter();
        }, 300000);
        // this.getRequisitionTaskKanban();
    }

    ngOnDestroy() {
        // Will clear when component is destroyed e.g. route is navigated away from.
        clearInterval(this.reloadInterval);
    }

    public loadRequisitionsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';

        this.filter();
    }

    showSidebarJustification(requisition) {
        this.selectRequisition = requisition;
        this.displaySidebarJustification = true;
        this.reloadListKanban(requisition);
    }

    closeSidebarJustification() {
        this.form2.reset();
        this.selectRequisition = undefined;
        this.displaySidebarJustification = false;
    }

    public newRequisitionJustification(values) {
        const param = {
            justification: values.justification,
            requisition_id: this.selectRequisition.id
        };
        if (values && this.form.valid) {
            const promise = this.requisitionJustificationService.newRequisitionJustification(this.selectRequisition.id, param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.getSynergoRequisitionJustification(this.selectRequisition.id);
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                    this.closeSidebarJustification();
                },
                error => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    getSynergoRequisitionJustification (id: number) {
        this.synergoRequisitionService.infoSynergoRequisition(id).toPromise().then(
            response => {
                this.edit1.requisition_justification = response.json().data[0].requisition_justification;
                this.form2.reset();
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecordsRequisitionJustification = response.json().meta.total_filtered;
                } else {
                    this.totalRecordsRequisitionJustification = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    showSidebarTask(requisition) {
        this.selectRequisition = requisition;
        this.displaySidebarTask = true;
    }

    closeSidebarTask() {
        this.form2.reset();
        this.selectRequisition = undefined;
        this.displaySidebarTask = true;
    }

    public getRequisitions() {
        this.loading = true;
        this.synergoRequisitionService.getSynergoRequisition(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.loading = false;
                this.requisitions = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getRequisitionsByCustomerguide(id: number) {
        this.loading = true;
        this.synergoRequisitionService.getSynergoRequisitionByCustomerGuide(id, this.page, this.per_page, this.sort, this.query,
            this.filters).toPromise().then(
            response => {
                this.loading = false;
                this.requisitions = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newRequisition() {
        this.modNew = !this.modNew;
        this.selectRequisition = null;
    }

    public savedRequisition(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectRequisition = null;
        this.modNew = false;
        //this.getRequisitions();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public cancelRequisition (res) {
        this.selectRequisition = null;
        this.modNew = false;
        this.modView = false;
        //this.getRequisitions();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public edit(requisition: Requisition) {
        this.modNew = true;
        this.selectRequisition = requisition;
        // this.getRequisitions();
    }

    public view(requisition: Requisition) {
        this.openRequisition = true;
        this.selectRequisition = requisition;
        this.RequisitionID = requisition.id;
        this.modView = true;
    }

    public deleteDialog(requisition: Requisition) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(requisition);
            }
        });
    }

    public delete(requisition: Requisition) {
        this.synergoRequisitionService.deleteSynergoRequisition(requisition.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                if (this.customerGuide) {
                    this.getRequisitionsByCustomerguide(this.customerGuide.id);
                } else if (this.params_id_customer_guide) {
                    this.getRequisitionsByCustomerguide(this.params_id_customer_guide);
                } else {
                    this.getRequisitions();
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeRequisition(requisition: Requisition) {
        this.putRequisition(requisition);
    }

    public putRequisition(values: Requisition) {
        const param = {
            // 'activated': values.activated
        };
        if (values) {
            const promise = this.synergoRequisitionService.updateSynergoRequisition(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public reloadListKanban(requisition) {
        this.listAbierta = [];
        this.listCerrada = [];

        requisition.requisition_task.forEach(element => {
            if (element.status === 'Abierta') {
                element.textColor = '#FFFFFF';
                element.color = '#ffc107';
                this.listAbierta.push (element);
            }
            if (element.status === 'Cerrada') {
                element.textColor = '#FFFFFF';
                element.color = '#28a745';
                this.listCerrada.push (element);
            }
        });
    }


    public onDropSuccessAbierta(e) {
        e.status = 'Abierta';
        const index = this.findElement(this.selectRequisition.requisition_task, e.id);
        this.selectRequisition.requisition_task[index].status = 'Abierta';
        this.selectRequisition.requisition_task[index].color = '#ffc107';
        this.putRequisitionTask(e);
    }

    public onDropSuccessCerrada(e) {
        e.status = 'Cerrada';
        const index = this.findElement(this.selectRequisition.requisition_task, e.id);
        this.selectRequisition.requisition_task[index].status = 'Cerrada';
        this.selectRequisition.requisition_task[index].color = '#28a745';
        this.putRequisitionTask(e);
    }

    public findElement (list, search) {
        let find = -1;
        let itera = 0;
        list.forEach(element => {
            if (element.id === search) {
                find = itera;
            }
            itera++;
        });
        return find;
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }
    public hasRole(rol){
        var r: boolean=false; 
        var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
        if(role == rol){ 
            r = true;
        }
        return (r);
    }

    public filterRefresh () {
        this.params_id_customer_guide = undefined;
        this.filter(true);
    }

    public filter (pageRefresh?) {
        if (pageRefresh) {
            this.page = 1;
            this.first = 0;
        }

        this.filters = [];
        if (this.company_id_filter.value) {
            if (this.company_id_filter.value.id) {
                if((this.company_id_filter.value.id !=5 && this.company_id_filter.value.id !=323)
                    || this.hasPermission("get company redes")){
                    this.filters.push({'key': 'customer_guide_id-lk', 'value': this.company_id_filter.value.customer_guide.id});
                    this.params_id_customer_guide = this.company_id_filter.value.customer_guide.id;
                    // if (this.params_id_customer_guide) 
                    //     this.params_id_customer_guide = this.company_id_filter.value.customer_guide.id;
                }
            }
        } else if (this.params_id_customer_guide) {
            if((this.params_id_customer_guide !=5 && this.params_id_customer_guide !=345) 
                || this.hasPermission("get company redes")){
                this.filters.push({'key': 'customer_guide_id-lk', 'value': this.params_id_customer_guide});
            }
        }

        if (this.params_id_requisition) {
            this.filters.push({'key': 'id-in', 'value': this.params_id_requisition});
        }

        if (this.employee_id_filter.value) {
            if (this.employee_id_filter.value) {
                this.filters.push({'key': 'employee_id-lk', 'value': this.employee_id_filter.value.id});
            }
        }
        if (this.venue_id_filter.value) {
            if (this.venue_id_filter.value) {
                this.filters.push({'key': 'venue_id-lk', 'value': this.venue_id_filter.value});
            }
        }
        if (this.status_filter.value.length>0 && this.status_filter.value.indexOf('all')=='-1' && this.status_filter.value.indexOf('')=='-1')// if (this.status_filter.value !== 'all' && this.status_filter.value !== '') {
            this.filters.push({'key': 'status-in', 'value': this.status_filter.value});
        
        if (this.type_filter.value.length>0 && this.type_filter.value.indexOf('all')=='-1' && this.type_filter.value.indexOf('')=='-1'){//if (this.type_filter.value !== 'all' && this.type_filter.value !== '') {
            this.filters.push({'key': 'type-in', 'value': this.type_filter.value});
        }
        if (this.recruited_by_id_filter.value) {
            this.filters.push({'key': 'employee_recruitment_id', 'value': this.recruited_by_id_filter.value.id});
        }
        if (this.requisition_recruitment_filter.value) {
            if(this.requisition_recruitment_filter.value == 'Reclutamiento solicitado'){
                this.filters.push({'key': 'requested_recruitment', 'value': '1'});
            }   
            else if(this.requisition_recruitment_filter.value == 'Reclutamiento solicitado no asignado'){
                this.filters.push({'key': 'requested_recruitment', 'value': '1'});
                this.filters.push({'key': 'employee_recruitment_id', 'value': null});
            }
            else
                this.filters.push({'key': 'requested_recruitment-lk', 'value': ''});
        }
        if (this.customerGuide) {
            this.getRequisitionsByCustomerguide(this.customerGuide.id);
        } else if (this.params_id_customer_guide) {
            this.getRequisitionsByCustomerguide(this.params_id_customer_guide);
        } else {
            this.getRequisitions();
        }
    }

    getRequisitionsById(query?: string, filters?: any[]) {
        this.loading = true;
        this.synergoRequisitionService.getSynergoRequisition(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.loading = false;
                this.edit(response.json().data[0]);
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public gotoCitations(id) {
        this.router.navigate(['/pages/selection/citations'], { queryParams: { id_requisition: id } });
    }

    getCompanies(query?: string, filters?: any[]) {
        this.companyService.getCompany(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                const companiesOptions = response.json().data;
                this.company_id_filter.setValue(companiesOptions[0]);
            },
            error => {
                this.company_id_filter.setValue(undefined);
            }
        );
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReport(values) {
        if (values.f4_export_filter === 'pdf') {
            this.exportReportPdf(values);
        } else if (values.f4_export_filter === 'excel') {
            this.exportReportExcel(values);
        } else {
            this.exportReportEmail(values);
        }
    }

    public exportReportPdf(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/requisitions/getReportRequisitionPDF?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=venue_id,employee_id,company_id&';

        if (f4_date_start) {
            url = url + 'requested_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'requested_at-max=' + f4_date_end + '&';
        }

        if (values.f4_venue_id) {
            url = url + 'venue_id-in=' + values.f4_venue_id + '&';
        }

        if (values.f4_employee_id) {
            url = url + 'employee_id-in=' + values.f4_employee_id.id + '&';
        }

        if (values.f4_status_filter !== 'all' && values.f4_status_filter !== '') {
            url = url + 'status-in=' + values.f4_status_filter + '&';
        }

        if (values.f4_type_filter !== 'all' && values.f4_type_filter !== '') {
            url = url + 'type=' + values.f4_type_filter + '&';
        }

        if (values.f4_export_type_filter) {
            url = url + 'type_export=' + values.f4_export_type_filter.value + '&';
        }

        window.open(url, '_blank');
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/requisitions/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=venue_id,employee_id,company_id&';

        if (f4_date_start) {
            url = url + 'requested_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'requested_at-max=' + f4_date_end + '&';
        }

        if (values.f4_venue_id) {
            url = url + 'venue_id-in=' + values.f4_venue_id + '&';
        }

        if (values.f4_employee_id) {
            url = url + 'employee_id-in=' + values.f4_employee_id.id + '&';
        }

        if (values.f4_company_id) {
            url = url + 'company_id-in=' + values.f4_company_id.id + '&';
        }
        if(values.f4_status_filter.indexOf('all')=='-1'){// if (values.f4_status_filter !== 'all' && values.f4_status_filter !== '') {
            url = url + 'status-in=' + values.f4_status_filter + '&';
        }

        if (values.f4_type_filter.indexOf('all')=='-1'){// if (values.f4_type_filter !== 'all' && values.f4_type_filter !== '') {
            url = url + 'type-in=' + values.f4_type_filter + '&';
        }

        if (values.f4_export_type_filter) {
            url = url + 'type_export=' + values.f4_export_type_filter.value + '&';
        }

        window.open(url, '_blank');
    }

    public exportReportEmail(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/requisitions/email?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=venue_id,employee_id,company_id&';

        if (f4_date_start) {
            url = url + 'requested_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'requested_at-max=' + f4_date_end + '&';
        }

        if (values.f4_venue_id) {
            url = url + 'venue_id-in=' + values.f4_venue_id + '&';
        }

        if (values.f4_employee_id) {
            url = url + 'employee_id-in=' + values.f4_employee_id.id + '&';
        }

        if (values.f4_status_filter !== 'all' && values.f4_status_filter !== '') {
            url = url + 'status-in=' + values.f4_status_filter + '&';
        }

        if (values.f4_type_filter !== 'all' && values.f4_type_filter !== '') {
            url = url + 'type-in=' + values.f4_type_filter + '&';
        }

        if (values.f4_export_type_filter) {
            url = url + 'type=' + values.f4_export_type_filter.value + '&';
        }

        window.open(url, '_blank');
    }

    getDiffDate(value) {
        let dateStart = new Date(value.requested_at);

        let dateEnd;

        if (value.wait_client_at) {
            dateEnd = new Date(value.wait_client_at);
        } else if (value.closed_at) {
            dateEnd = new Date(value.closed_at);
        } else {
            dateEnd = new Date();
        }

        const diff = dateEnd.getTime() - dateStart.getTime();  //msec
        return Math.ceil(diff / (1000 * 3600 * 24));
    }

    showFormCreateTask() {
        this.showCreateTask = true;
    }

    hideFormCreateTask () {
        this.showCreateTask = false;
        this.closeSidebarJustification();
    }

    public putRequisitionTask(values: RequisitionTask) {
        const param = {
            'status': values.status,
        };
        if (values) {
            const promise = this.requisitionTaskService.updateRequisitionTask(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                    this.reloadListKanban(this.selectRequisition);
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
    getDiffDateSendCustomer(value) {
        let dateStart = new Date(value.requested_at);
        var dateEnd = new Date(value.requested_at);
        let weekDay= dateEnd.getDay();
        var sumdays=0;
        if(weekDay == 1 || weekDay ==2)
            sumdays=4;//dateEnd= dateEnd+4;
        else if(weekDay == 3 || weekDay ==5)
            sumdays=6;
        else if(weekDay == 4)
            sumdays=5;
        else
            sumdays=5;
        dateEnd.setDate(dateEnd.getDate() + sumdays);
       
        var countSendCustomeratTime = 0;
        if(value.citation_count > 0)
        {
            value.citation.forEach(citation => {
                if(citation.start_send_customer != null){
                    let dateSendCustomer = new Date(citation.start_send_customer);
                    // let diff = dateSendCustomer.getTime() - dateEnd.getTime() ;
                    if(dateSendCustomer < dateEnd)
                        countSendCustomeratTime++;
                
                }
            });
            if(countSendCustomeratTime>0)
                return "Cumple";
            else
                return this.comparedatelimit(dateStart,sumdays);
            
                
        }
        else
            return this.comparedatelimit(dateStart,sumdays);
        
    }
    public comparedatelimit(dateStart,sumdays )
    {
        var inicio = new Date();
        const diff = inicio.getTime() - dateStart.getTime();  //msec
        var daysCount = Math.ceil(diff / (1000 * 3600 * 24));
        if(daysCount > sumdays)
            return "No cumple";
        else
            return "-";
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/synergo/synergo-requisitions/synergo-requisitions.component.ts